var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gray-route-log-container" },
    [
      _c(
        "el-form",
        {
          staticClass: "search-form",
          attrs: { inline: true, model: _vm.queryParams, size: "small" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "openId" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "微信openId", clearable: "" },
                model: {
                  value: _vm.queryParams.openId,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "openId", $$v)
                  },
                  expression: "queryParams.openId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "用户ID" } },
            [
              _c("el-input", {
                staticStyle: { width: "120px" },
                attrs: { placeholder: "用户ID", clearable: "" },
                model: {
                  value: _vm.queryParams.userId,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "userId", $$v)
                  },
                  expression: "queryParams.userId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "页面路径" } },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { placeholder: "如 pages/order/list", clearable: "" },
                model: {
                  value: _vm.queryParams.pagePath,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "pagePath", $$v)
                  },
                  expression: "queryParams.pagePath",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "手机号" } },
            [
              _c("el-input", {
                staticStyle: { width: "150px" },
                attrs: { placeholder: "完整手机号", clearable: "" },
                model: {
                  value: _vm.queryParams.mobilePhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "mobilePhone", $$v)
                  },
                  expression: "queryParams.mobilePhone",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "卡号" } },
            [
              _c("el-input", {
                staticStyle: { width: "160px" },
                attrs: { placeholder: "完整卡号", clearable: "" },
                model: {
                  value: _vm.queryParams.cardNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "cardNo", $$v)
                  },
                  expression: "queryParams.cardNo",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "来源" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "120px" },
                  attrs: { placeholder: "全部", clearable: "" },
                  model: {
                    value: _vm.queryParams.source,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "source", $$v)
                    },
                    expression: "queryParams.source",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "城市", value: "CITY" } }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "门店", value: "STORE_ID" },
                  }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "IP", value: "IP_GEO" } }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "时间" } },
            [
              _c("el-date-picker", {
                staticStyle: { width: "360px" },
                attrs: {
                  type: "datetimerange",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                },
                model: {
                  value: _vm.timeRange,
                  callback: function ($$v) {
                    _vm.timeRange = $$v
                  },
                  expression: "timeRange",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleQuery },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.handleReset },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.list,
            border: "",
            size: "small",
            "empty-text": "暂无数据",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "70", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "openId",
              label: "openId",
              "min-width": "200",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "userId",
              label: "用户ID",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.userId
                      ? _c("span", [_vm._v(_vm._s(scope.row.userId))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "mobilePhone",
              label: "手机号",
              width: "130",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.mobilePhone
                      ? _c("span", [_vm._v(_vm._s(scope.row.mobilePhone))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "cardNo",
              label: "卡号",
              width: "150",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.cardNo
                      ? _c("span", [_vm._v(_vm._s(scope.row.cardNo))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ip", label: "IP", width: "130", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.ip
                      ? _c("span", [_vm._v(_vm._s(scope.row.ip))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "pagePath",
              label: "页面路径",
              "min-width": "180",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "cityName",
              label: "城市",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.cityName
                      ? _c("span", [_vm._v(_vm._s(scope.row.cityName))])
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "source",
              label: "来源",
              width: "90",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.source
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type: _vm.sourceTagType(scope.row.source),
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.sourceLabel(scope.row.source)) +
                                "\n        "
                            ),
                          ]
                        )
                      : _c("span", { staticStyle: { color: "#ccc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "访问时间",
              width: "160",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatDateTime(scope.row.createTime))),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("el-pagination", {
            staticStyle: { "margin-top": "15px", "text-align": "right" },
            attrs: {
              "current-page": _vm.queryParams.page,
              "page-size": _vm.queryParams.limit,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [10, 20, 50, 100],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }